import {match} from 'ts-pattern';

import {isNotNil} from 'ramda-adjunct';

function getBorderTokens(border: string) {
  let depth = 0;
  return border
    .replace(/\(|\)|\s+/g, (separator) => {
      depth = match(separator)
        .with('(', () => depth + 1)
        .with(')', () => depth - 1)
        .otherwise(() => depth);
      return depth === 0 && /^\s+$/.test(separator) ? '\0' : separator;
    })
    .split('\0')
    .filter(Boolean);
}

export function getBorderStyles(border: string | undefined, color: string | undefined) {
  const tokens = getBorderTokens(border ?? '');
  const global = match(tokens.length === 1 ? tokens[0]?.toLowerCase() : undefined)
    .with('inherit', 'initial', 'unset', 'revert', 'revert-layer', (value) => value)
    .otherwise(() => undefined);
  const style = tokens
    .map((token) =>
      match(token.toLowerCase())
        .with(
          'none',
          'hidden',
          'solid',
          'dashed',
          'dotted',
          'double',
          'groove',
          'ridge',
          'inset',
          'outset',
          (value) => value
        )
        .otherwise(() => undefined)
    )
    .find(isNotNil);
  const variables = tokens.filter((token) => /^var\(/i.test(token));
  const definiteTokens = tokens.filter((token) => !/^var\(/i.test(token));
  const definiteWidth = definiteTokens.find((token) =>
    /^([\d.-]|thin$|medium$|thick$|(?:calc|clamp|min|max)\()/i.test(token)
  );
  const width = definiteWidth ?? variables[0];
  const inlineColor =
    definiteTokens.find((token) => token.toLowerCase() !== style && token !== definiteWidth) ??
    variables[isNotNil(definiteWidth) ? 0 : 1];
  return {
    width: global ?? width ?? (tokens.length > 0 ? 'medium' : undefined),
    style: global ?? style ?? (tokens.length > 0 ? 'none' : undefined),
    color: color ?? global ?? inlineColor,
  };
}
